import React from 'react';
import { Section } from './ui/Section';
import { Target, Shield, TrendingUp, Headphones } from 'lucide-react';
const benefits = [{
  icon: Shield,
  title: 'Disciplina a Prueba de Fallos',
  description: 'Mantén tus hábitos incluso cuando tu fuerza de voluntad es baja y la motivación desaparece.'
}, {
  icon: Target,
  title: 'Sin Culpas ni Reproches',
  description: 'Aprende a volver al camino inmediatamente después de un tropiezo, sin castigarte.'
}, {
  icon: TrendingUp,
  title: 'Resultados Sostenibles',
  description: 'Consigue resultados reales con pasos mínimos diarios que se acumulan con el tiempo.'
}, {
  icon: Headphones,
  title: 'Meditaciones + Workbook',
  description: 'Incluye meditaciones guiadas y un workbook práctico para aplicar el sistema desde el día uno.'
}];
export function BenefitsSection() {
  return <Section className="bg-transparent" data-id="element-47">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-48">
        {benefits.map((benefit, index) => <div key={index} className="group p-8 rounded-2xl bg-black/50 backdrop-blur-md border border-[#D4AF37]/20 hover:border-[#D4AF37]/40 transition-colors duration-300 shadow-xl" data-id="element-49">
            <div className="w-12 h-12 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/30 transition-colors duration-300" data-id="element-50">
              <benefit.icon className="w-6 h-6 text-[#D4AF37]" data-id="element-51" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-52">
              {benefit.title}
            </h3>
            <p className="text-gray-200 leading-relaxed" data-id="element-53">
              {benefit.description}
            </p>
          </div>)}
      </div>
    </Section>;
}